import {connect} from '@modifi/redux'
import {aCloseDialog} from '@modifi/plugin-dialogs'

import InternalNoteDialog, {InternalNoteProps} from './InternalNoteDialog'
import {aReset, aSubmit, selectUpdateErrorMessage, selectUpdatePending} from '../../store'

const mapStateToProps = (
  state: Record<string, any>
): Pick<InternalNoteProps, 'isUpdatePending' | 'errorMessage'> => ({
  isUpdatePending: selectUpdatePending(state),
  errorMessage: selectUpdateErrorMessage(state),
})

const mapDispatchToProps = {
  submit: aSubmit,
  reset: aReset,
  discard: aCloseDialog,
}

export const DIALOG_NAME = 'tasks/internal-note'
export default connect(mapStateToProps, mapDispatchToProps)(InternalNoteDialog)
